import moment from 'moment';

export default function formatDateTime(dateTime, format = 'DD/MM/YYYY [às] HH[h]mm') {
    return dateTime
        ? moment(dateTime).format(format)
        : null;
}
